import { ErrorComponent } from "./errorComponent";

export { ErrorComponent, ErrorComponent as Error };
